import { api } from './api';

// Search types matching backend
export type MatterSearchType = 'matterId' | 'displayNumber' | 'number';
export type BankAccountSearchType = 'bankAccountId' | 'accountNumber' | 'name';

export interface MatterSearchResult {
  matterId: string;
  displayNumber: string;
  number?: number;
  description?: string;
  status: string;
  clientName?: string;
  clientId?: string;
}

export interface BankAccountSearchResult {
  bankAccountId: string;
  name: string;
  accountNumber?: string;
  type?: string;
  balance?: number;
  institution?: string;
}

/**
 * General-purpose Clio search API client
 * Can be used across any feature in the application
 */
export const clioSearchApi = {
  /**
   * Search for matters by ID, display number, or number
   * @param params Search parameters
   * @returns List of matching matters
   */
  searchMatters: async (params: {
    searchType: MatterSearchType;
    searchValue: string;
    limit?: number;
  }): Promise<{ matters: MatterSearchResult[] }> => {
    return api.post('/clio/search/matters', params);
  },

  /**
   * Search for bank accounts by ID, account number, or name
   * @param params Search parameters
   * @returns List of matching bank accounts
   */
  searchBankAccounts: async (params: {
    searchType: BankAccountSearchType;
    searchValue: string;
    limit?: number;
  }): Promise<{ bankAccounts: BankAccountSearchResult[] }> => {
    return api.post('/clio/search/bank-accounts', params);
  },
};
